import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getCadConfig } from "../redux/selectors";

export const LinearCad = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const cadProps = useSelector(getCadConfig);

  const { url, xml } = cadProps;

  useEffect(() => {
    if (formRef) {
      formRef.current!.submit();
    }
  }, [formRef]);

  return (
    <>
      <form ref={formRef} action={url} method="post" target="containerIframe">
        <input type="hidden" name="QnADisplayType" value="1" />
        <input type="hidden" name="XmlContent" value={xml} />
      </form>
      <iframe className="scha__lc__iframe-cad" name={"containerIframe"}></iframe>
    </>
  );
};
